// Dates arrive from the API as "YYYY-MM-DD". Build them as local dates so
// they never shift a day because of the time zone.
export function formatDate(value) {
  if (!value) return "—";
  const [y, m, d] = String(value).split("-").map(Number);
  if (!y || !m || !d) return value;
  return new Date(y, m - 1, d).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

export function greeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

export function firstName(emailOrName) {
  if (!emailOrName) return "";
  const base = String(emailOrName).split("@")[0].split(/[._\s-]/)[0];
  return base.charAt(0).toUpperCase() + base.slice(1);
}

export function percent(part, total) {
  return total > 0 ? Math.round((part * 100) / total) : 0;
}
